import { LoginPage } from './LoginPage';

export interface NotProvisionedScreenProps {
  /** The signed-in account's email, shown in the explanatory copy. */
  email?: string | null;
  /** Sign the user out (full reload back to login). */
  onSignOut: () => void | Promise<void>;
  /** Re-check claims (force token refresh) — e.g. right after being onboarded. */
  onRetry?: () => void | Promise<void>;
  /** Path to logo image (falls through to LoginPage's default). */
  logoSrc?: string;
}

/**
 * Shown when a user is authenticated but has no `tenantId` claim yet — their
 * account exists but is not assigned to an organization. Reuses LoginPage's
 * glass shell for visual consistency.
 */
export function NotProvisionedScreen({
  email,
  onSignOut,
  onRetry,
  logoSrc,
}: NotProvisionedScreenProps) {
  return (
    <LoginPage
      title="החשבון אינו משויך לארגון"
      subtitle={email ? `החשבון ${email} עדיין לא שויך לארגון` : 'החשבון שלך עדיין לא שויך לארגון'}
      logoSrc={logoSrc}
    >
      <p className="mb-6 text-center text-sm text-white drop-shadow-md">
        פנה למנהל המערכת כדי לקבל גישה.
      </p>

      {onRetry && (
        <button
          onClick={() => onRetry()}
          className="mb-4 flex min-h-[52px] w-full transform items-center justify-center gap-3 rounded-xl bg-white py-4 text-base text-gray-900 shadow-xl transition-[background-color,box-shadow,transform] hover:scale-105 hover:bg-gray-50 hover:shadow-2xl md:text-lg"
        >
          בדוק שוב
        </button>
      )}

      <button
        onClick={() => onSignOut()}
        className="flex min-h-[52px] w-full transform items-center justify-center gap-3 rounded-xl border border-white/40 bg-white/10 py-4 text-base text-white shadow-xl backdrop-blur-sm transition-[background-color,box-shadow,transform] hover:scale-105 hover:bg-white/20 hover:shadow-2xl md:text-lg"
      >
        התנתק
      </button>
    </LoginPage>
  );
}
